var map = {
	"./404.svg": 939,
	"./Categories.png": 940,
	"./Edit-menu.svg": 941,
	"./Egg.svg": 942,
	"./Emaier-Header.png": 943,
	"./Qr-4.png": 944,
	"./_duplicate.svg": 945,
	"./_overview.svg": 946,
	"./add-white.svg": 947,
	"./alert.svg": 948,
	"./all_category.svg": 949,
	"./archive.svg": 950,
	"./armchair.svg": 951,
	"./arrow-circle-right.svg": 952,
	"./arrow-left-circle.svg": 953,
	"./arrow-right-circle.svg": 954,
	"./arrow-right.svg": 352,
	"./asc-up-white.svg": 955,
	"./asc.png": 956,
	"./asc.svg": 957,
	"./back-arrow.svg": 958,
	"./barcode-icon.svg": 959,
	"./beverages.svg": 960,
	"./blue-edit-pen.svg": 961,
	"./blue-eye.svg": 962,
	"./box-office.svg": 963,
	"./broken-seat.jpg": 964,
	"./calendar_list.svg": 965,
	"./chevron-down.svg": 966,
	"./chevron-left.svg": 967,
	"./cinema-mamagement-sidebar.svg": 968,
	"./claendar.svg": 303,
	"./clock-1.svg": 969,
	"./clock.svg": 970,
	"./close-button.svg": 700,
	"./close-white.svg": 706,
	"./close-x.svg": 296,
	"./collapse-up.svg": 971,
	"./collapse.svg": 972,
	"./connection-lost.svg": 302,
	"./copy.svg": 973,
	"./copy_image_icon.png": 974,
	"./delete-red-light.svg": 975,
	"./delete-red.svg": 707,
	"./delete.svg": 685,
	"./deliver-icon.svg": 976,
	"./desc-down-white.svg": 977,
	"./desc.svg": 978,
	"./distributors-sidebar.svg": 979,
	"./download.svg": 980,
	"./dragndrop.svg": 981,
	"./dragndrop2.svg": 982,
	"./duplicate.svg": 983,
	"./duplicateScreen.svg": 984,
	"./e-wallet-icon-black.svg": 985,
	"./edit-pen-blue.svg": 986,
	"./edit-pen-white.svg": 987,
	"./edit-pen.svg": 988,
	"./edit.svg": 989,
	"./email.png": 990,
	"./empty-image.svg": 991,
	"./excel.svg": 992,
	"./external-link.svg": 993,
	"./eye.svg": 994,
	"./filter-icon.svg": 353,
	"./flag.svg": 995,
	"./fnb-beverages.svg": 996,
	"./fnb-brownie.svg": 997,
	"./fnb-combo.svg": 998,
	"./fnb-desert.svg": 999,
	"./fnb-eatables.svg": 1000,
	"./fnb-make-your-combo.svg": 1001,
	"./fnb-popcorn.svg": 1002,
	"./fnbtransactionIcon.svg": 1003,
	"./fullscreen-icon.svg": 708,
	"./funnel.svg": 1004,
	"./globe.svg": 1005,
	"./green-tick.svg": 1006,
	"./grid-view.svg": 1007,
	"./hide-password.svg": 354,
	"./home-icon.svg": 1008,
	"./home.svg": 1009,
	"./icon-black-play.svg": 1010,
	"./icon-dot.svg": 1011,
	"./icon-fnb.svg": 1012,
	"./icon-marketing.svg": 1013,
	"./icon-no-seat.png": 1014,
	"./icon-no-seat.svg": 1015,
	"./icon-option.svg": 1016,
	"./icon-poin-of-sale.svg": 1017,
	"./icon-recliner.svg": 1018,
	"./icon-report.svg": 1019,
	"./icon-sofa-dark-1.svg": 1020,
	"./icon-sofa-dark.png": 1021,
	"./icon-sofa-dark.svg": 1022,
	"./icon-sofa.svg": 1023,
	"./importfile.svg": 1024,
	"./info.svg": 702,
	"./info2.svg": 1025,
	"./keyboard-icon.svg": 1026,
	"./kitchen_display.svg": 1027,
	"./language-icon.svg": 297,
	"./left-caret.svg": 1028,
	"./link.svg": 1029,
	"./list-view.svg": 1030,
	"./loading.svg": 355,
	"./lock.svg": 1031,
	"./login-password.png": 356,
	"./login-user.png": 357,
	"./logout.svg": 709,
	"./masters-sidebar.svg": 1032,
	"./merchandise.svg": 1033,
	"./minus.svg": 1034,
	"./movie-pass-svg.svg": 689,
	"./movie-rolling.svg": 1035,
	"./mulitSchedule.svg": 1036,
	"./multicurrency.svg": 1037,
	"./multifnb.svg": 1038,
	"./nav-plus.svg": 1039,
	"./no-image.svg": 1040,
	"./no-schedule.svg": 132,
	"./non-veg-mark.png": 1041,
	"./non-veg-mark.svg": 1042,
	"./notification.svg": 1043,
	"./open-link-blue.svg": 1044,
	"./openPlanned.svg": 1045,
	"./overview.svg": 1046,
	"./overview2.svg": 1047,
	"./pdf-icon.svg": 1048,
	"./pdf.svg": 1049,
	"./pickup-ticket-icon.svg": 1050,
	"./pickupfnb.svg": 1051,
	"./play.svg": 1052,
	"./plus.svg": 1053,
	"./pointofsale-1.svg": 1054,
	"./pointofsale-2.svg": 1055,
	"./pointofsale.png": 1056,
	"./portfolio.svg": 1057,
	"./pos-fnb-no-itmes.svg": 696,
	"./pos-refresh.svg": 1058,
	"./primary/chevron-down.svg": 1059,
	"./primary/download.svg": 1060,
	"./primary/edit.svg": 1061,
	"./primary/filter.svg": 1062,
	"./primary/printer.svg": 1063,
	"./print-icon.svg": 1064,
	"./print.svg": 1065,
	"./question.svg": 1066,
	"./question1.svg": 1067,
	"./question2.svg": 710,
	"./question3.svg": 1068,
	"./recliner-1.svg": 1069,
	"./recliner.png": 1070,
	"./refund-icon.svg": 1071,
	"./reload-icon-pos.svg": 1072,
	"./reload-icon.svg": 1073,
	"./restore.svg": 1074,
	"./right-caret.svg": 1075,
	"./role-management-sidebar.svg": 1076,
	"./save.svg": 1077,
	"./schedule-icon.svg": 1078,
	"./school-calendar.svg": 1079,
	"./search-global-white.svg": 1080,
	"./search-global.svg": 1081,
	"./search.svg": 1082,
	"./searchIcon.svg": 1083,
	"./seat-icon-2.svg": 1084,
	"./seat-icon.svg": 1085,
	"./seat-icons/3-wheelChair.png": 1086,
	"./seat-icons/block_seat_new.png": 1087,
	"./seat-icons/broken-seat-1.svg": 1088,
	"./seat-icons/broken-seat-2.svg": 1089,
	"./select-food.png": 711,
	"./settings.svg": 1090,
	"./show-password.svg": 358,
	"./slider-triangle.svg": 1091,
	"./snack.svg": 712,
	"./sort.svg": 1092,
	"./star-empty.svg": 1093,
	"./star-fill.svg": 1094,
	"./statistics.svg": 1095,
	"./success-tick.svg": 1096,
	"./suitcase.svg": 1097,
	"./swap.svg": 1098,
	"./tick-green-item.svg": 713,
	"./tick-green.svg": 1099,
	"./ticket-icon.svg": 1100,
	"./trash.svg": 1101,
	"./unpaid-reservation.svg": 688,
	"./updown-white.svg": 1102,
	"./updown.svg": 1103,
	"./user-attribute.svg": 1104,
	"./user-attributes.svg": 1105,
	"./user-female.svg": 1106,
	"./user-male-white.svg": 1107,
	"./user-male.svg": 1108,
	"./user-profile.svg": 298,
	"./userProfile.png": 1109,
	"./veg-food-mark-white.png": 1110,
	"./veg-foog-mark-trans.png": 1111,
	"./view.png": 1112,
	"./view.svg": 1113
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 938;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons ^\.\/.*$
// module id = 938
// module chunks = 34